import { useMemo } from 'react';

import { useSaveStoreSelector } from 'pages/audience/shared/save/hooks';

export const useIsAudience = () => {
  const formType = useSaveStoreSelector(({ formType }) => formType);

  return useMemo(() => {
    return formType === 'audience' || formType === 'audience-master-file' || formType === 'audience-pre-built';
  }, [formType]);
};
